import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class ApplicationSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "product_type",
        label: "Product Type",
        type: "select",
        options: [],
        placeholder: "Product Type",
      },
      {
        name: "customer_name",
        label: "Customer Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_LOAN_STATUS,
        placeholder: "Application Status",
      },
    ];
    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  }

  componentDidMount() {
    this.getProductTypes();
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      console.log({ res });

      let productType = this.fields.find((o) => o.name == "product_type");
      productType.options = res;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(ApplicationSearch);
